import { isConnectAppUserMessage } from '@/utils/connectAppAssistantPayload'
import { isCreateAgentQuestionPrompt } from '@/features/chat/agentQuestion/isCreateAgentQuestionPrompt.js'
import { isGeneratedArtifactUserMessage } from '@/utils/generatedArtifactAssistantPayload'

/** @param {string} trimmed */
export function pendingAgentMeta(trimmed) {
  if (
    trimmed.toLowerCase() === 'response component' ||
    isCreateAgentQuestionPrompt(trimmed) ||
    isConnectAppUserMessage(trimmed) ||
    isGeneratedArtifactUserMessage(trimmed)
  ) {
    return {
      agentBrand: 'SIA',
      agentName: 'Master Root Agent',
      thoughtSummary: 'Thinking…',
    }
  }
  return {}
}
